const dbAddOns = [
  {
    id: "DtwHQHpkmPP",
    name: "Gatorade",
    price: 30.0,
    description: "24-pack, 20 oz bottles, various flavors",
    imageSrc:
      "https://tourney-tents-web-images.s3.amazonaws.com/addOns-gatoradeCase.png",
    quantity: 0,
    stillOffered: true,
    availability: "ALA_CARTE",
  },
  {
    id: "dzMdFmPWPDz",
    name: "Water",
    price: 20.0,
    description: "40-pack, 16.9 oz bottles",
    imageSrc:
      "https://tourney-tents-web-images.s3.amazonaws.com/addOns-bottledWaterCase.png",
    quantity: 0,
    stillOffered: true,
    availability: "ALA_CARTE",
  },
  {
    id: "BHGcnckTrLp",
    name: "Bagels",
    price: 70.0,
    description:
      "20 plain, sliced bagels with three 1/2 lb cream cheese containers",
    imageSrc:
      "https://tourney-tents-web-images.s3.amazonaws.com/addOns-bagelsCreamCheese.png",
    quantity: 0,
    stillOffered: true,
    availability: "ALA_CARTE",
  },
];

const dbPackages = [
  {
    name: "Standard Package",
    id: "WjKmpGRTqTP",
    href: "#",
    price: 1000,
    discountText: "",
    description:
      "Our premier concierge package. Everything you need for a successful tournament.",
    features: [
      "1 tent",
      "1 table",
      "2x 6-seat benches",
      "1 cooler with ice",
      "Set up / breakdown",
    ],
    stillOffered: true,
    availability: "BUNDLE",
  },
  {
    name: "Double Package",
    id: "wqCMPGG7Q6b",
    href: "#",
    price: 1850,
    discountText: "Save more on your second set",
    description: "Two times the fun! Save more on your second package.",
    features: [
      "2 tents",
      "2 tables",
      "4x 6-seat benches",
      "2 coolers with ice",
      "Set up / breakdown",
    ],
    stillOffered: true,
    availability: "BUNDLE",
  },
];

const dbTournaments = [
  // {
  //   id: "NwPFqkCBfgc",
  //   name: "Turning Point (Trilogy)",
  //   city: "North East",
  //   state: "MD",
  //   dateString: "May 31, 2025 (Day 1)",
  //   numberOfDays: 1,
  //   sport: "LACROSSE",
  //   gender: "BOYS",
  //   link: "https://trilogylacrosse.com/events/turning-point/",
  //   imageAlt: "Turning Point: Trilogy",
  //   imageSrc: "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/turningPoint.png",
  //   startTimestamp: "2025-05-31T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-05-28T13:00:00.000Z",
  //   singlePrice: 500,
  //   doublePrice: 800,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "jPCWPdpJWRt",
  //   name: "Turning Point (Trilogy)",
  //   city: "North East",
  //   state: "MD",
  //   dateString: "June 1, 2025 (Day 2)",
  //   numberOfDays: 1,
  //   sport: "LACROSSE",
  //   gender: "BOYS",
  //   link: "https://trilogylacrosse.com/events/turning-point/",
  //   imageAlt: "Turning Point: Trilogy",
  //   imageSrc: "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/turningPoint.png",
  //   startTimestamp: "2025-06-01T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-05-30T13:00:00.000Z",
  //   singlePrice: 500,
  //   doublePrice: 800,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "fBTB9qcKkjR",
  //   name: "Summer Exposure (HoganLax)",
  //   city: "Annapolis",
  //   state: "MD",
  //   dateString: "June 14-15, 2025",
  //   numberOfDays: 2,
  //   sport: "LACROSSE",
  //   gender: "BOYS",
  //   link: "https://hoganlax.com/exposure/",
  //   imageAlt: "Summer Exposure: HoganLax",
  //   imageSrc:
  //     "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/summerExposure.png",
  //   startTimestamp: "2025-06-14T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-06-12T13:00:00.000Z",
  //   singlePrice: 900,
  //   doublePrice: 1200,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "MGDW8CpkHBR",
  //   name: "NHSLS Varsity (RED)",
  //   city: "Columbia",
  //   state: "MD",
  //   dateString: "June 19-20, 2025",
  //   numberOfDays: 2,
  //   sport: "LACROSSE",
  //   gender: "BOYS",
  //   link: "https://nhsls.com/boys/",
  //   imageAlt: "NHSLS Varsity (RED)",
  //   imageSrc:
  //     "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/nhslsLogo.png",
  //   startTimestamp: "2025-06-19T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-06-17T13:00:00.000Z",
  //   singlePrice: 850,
  //   doublePrice: 1050,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "ptGJCKmfTQt",
  //   name: "#LaxIsLife",
  //   city: "North East",
  //   state: "MD",
  //   dateString: "June 21-22, 2025",
  //   numberOfDays: 2,
  //   sport: "LACROSSE",
  //   gender: "GIRLS",
  //   link: "https://topofthebaysports.com/summer-tournaments/post-4011/",
  //   imageAlt: "#LaxIsLife",
  //   imageSrc:
  //     "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/laxIsLife.png",
  //   startTimestamp: "2025-06-21T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-06-19T13:00:00.000Z",
  //   singlePrice: 900,
  //   doublePrice: 1200,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "7FkkjDLLgk7",
  //   name: "CrabFeast",
  //   city: "Baltimore",
  //   state: "MD",
  //   dateString: "June 21-22, 2025",
  //   numberOfDays: 2,
  //   sport: "LACROSSE",
  //   gender: "BOYS",
  //   link: "https://crabfeast.net",
  //   imageAlt: "CrabFeast",
  //   imageSrc:
  //     "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/crabFeast.png",
  //   startTimestamp: "2025-06-21T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-06-19T13:00:00.000Z",
  //   singlePrice: 900,
  //   doublePrice: 1200,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "cdqnJ9kc9Ww",
  //   name: "Champions Cup (Elite Tournaments)",
  //   city: "Boyds",
  //   state: "MD",
  //   dateString: "June 21-22, 2025",
  //   numberOfDays: 2,
  //   sport: "LACROSSE",
  //   gender: "GIRLS",
  //   link: "https://iwlcarecruiting.com/tournaments/iwlca-champions-cup-v2/",
  //   imageAlt: "Champions Cup",
  //   imageSrc:
  //     "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/championsCup.png",
  //   startTimestamp: "2025-06-21T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-06-19T13:00:00.000Z",
  //   singlePrice: 900,
  //   doublePrice: 1200,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "7tqmKtfkCFz",
  //   name: "NHSLS Varsity (WHITE)",
  //   city: "Columbia",
  //   state: "MD",
  //   dateString: "June 26-27, 2025",
  //   numberOfDays: 2,
  //   sport: "LACROSSE",
  //   gender: "BOYS",
  //   link: "https://nhsls.com/boys/",
  //   imageAlt: "NHSLS Varsity (White)",
  //   imageSrc:
  //     "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/nhslsLogo.png",
  //   startTimestamp: "2025-06-26T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-06-24T13:00:00.000Z",
  //   singlePrice: 850,
  //   doublePrice: 1050,
  //   localSalesTax: 0.06,
  // },
  // {
  //   id: "BtQ9z9z6mcG",
  //   name: "Naptown Challenge (HoganLax)",
  //   city: "Annapolis",
  //   state: "MD",
  //   dateString: "June 30-July 2, 2025",
  //   numberOfDays: 3,
  //   sport: "LACROSSE",
  //   gender: "BOYS",
  //   link: "https://hoganlax.com/naptown-challenge/",
  //   imageAlt: "Naptown Challenge",
  //   imageSrc:
  //     "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/naptownChallenge.png",
  //   startTimestamp: "2025-06-30T13:00:00.000Z",
  //   closeRegistrationTimestamp: "2025-06-19T13:00:00.000Z",
  //   singlePrice: 900,
  //   doublePrice: 1200,
  //   localSalesTax: 0.06,
  // },
  {
    id: "nmKdDGmMWqg",
    name: "Capital Cup (Elite Tournaments)",
    city: "Frederica",
    state: "DE",
    dateString: "July 11-13, 2025",
    numberOfDays: 3,
    sport: "LACROSSE",
    gender: "GIRLS",
    link: "https://iwlcarecruiting.com/tournaments/iwlca-capital-cup/",
    imageAlt: "Capital Cup",
    imageSrc:
      "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/capitalCup.png",
    startTimestamp: "2025-07-11T13:00:00.000Z",
    closeRegistrationTimestamp: "2025-07-09T13:00:00.000Z",
    singlePrice: 950,
    doublePrice: 1300,
    localSalesTax: 0.0,
  },
  {
    id: "cm8NgfR6tFN",
    name: "MidAtlantic Summer Club",
    city: "Baltimore",
    state: "MD",
    dateString: "July 18-20, 2025",
    numberOfDays: 3,
    sport: "LACROSSE",
    gender: "GIRLS",
    link: "https://robinsonsportsinc.com/midatlantic-summer-championships/",
    imageAlt: "MidAtlantic Summer Club",
    imageSrc:
      "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/midAtlanticSummerClub.png",
    startTimestamp: "2025-07-18T13:00:00.000Z",
    closeRegistrationTimestamp: "2025-07-16T13:00:00.000Z",
    singlePrice: 900,
    doublePrice: 1200,
    localSalesTax: 0.06,
  },
  {
    id: "hWPwcDhbcnJ",
    name: "Hogan Hershey",
    city: "Hershey",
    state: "PA",
    dateString: "July 12-13, 2025",
    numberOfDays: 2,
    sport: "LACROSSE",
    gender: "BOYS",
    link: "https://hoganlax.com/hogan-hershey/",
    imageAlt: "Hogan Hershey",
    imageSrc:
      "https://tourney-tents-web-images.s3.us-east-1.amazonaws.com/logos/hoganHershey.png",
    startTimestamp: "2025-07-12T13:00:00.000Z",
    closeRegistrationTimestamp: "2025-07-10T13:00:00.000Z",
    singlePrice: 950,
    doublePrice: 1300,
    localSalesTax: 0.06,
  },
];

const tournamentsWithoutBagels = [
  "NwPFqkCBfgc",
  "jPCWPdpJWRt",
  "fBTB9qcKkjR",
  "MGDW8CpkHBR",
  "7tqmKtfkCFz",
  "7FkkjDLLgk7",
  "cdqnJ9kc9Ww",
  "BtQ9z9z6mcG",
  "nmKdDGmMWqg",
  "cm8NgfR6tFN",
  "hWPwcDhbcnJ",
  "ptGJCKmfTQt",
];

const dbEventProductAvailability = [
  ...dbTournaments.flatMap((dbTournament) => [
    // Add all packages
    ...dbPackages.map((dbPackage) => ({
      id: `${dbTournament.id}-${dbPackage.id}`,
      eventId: dbTournament.id,
      productId: dbPackage.id,
      isAvailable: true,
    })),
    // Add all add-ons with conditional availability for Bagels
    ...dbAddOns.map((addOn) => ({
      id: `${dbTournament.id}-${addOn.id}`,
      eventId: dbTournament.id,
      productId: addOn.id,
      isAvailable:
        addOn.id === "BHGcnckTrLp"
          ? !tournamentsWithoutBagels.includes(dbTournament.id)
          : true,
    })),
  ]),
];

const dbDiscounts = [
  {
    id: "BD6CkWgJd8N",
    code: "EARLYBIRDFALL",
    description: "Get 20% off your entire order, now through 10/15!",
    type: "PERCENTAGE",
    value: 0.2,
    expirationDate: "2024-10-15T23:59:59Z",
    usageLimit: null,
    createdAt: "2024-09-24T00:00:00Z",
    updatedAt: "2024-09-24T00:00:00Z",
  },
  {
    id: "CzKD8FwJJqB",
    code: "FIELDREADY15",
    description: "Save 15% off on orders through 11/15.",
    type: "PERCENTAGE",
    value: 0.15,
    expirationDate: "2024-11-15T23:59:59Z",
    usageLimit: 100,
    createdAt: "2024-09-24T00:00:00Z",
    updatedAt: "2024-09-24T00:00:00Z",
  },
  {
    id: "QDFrqmpPGFT",
    code: "EARLYBIRD20",
    description: "For a limited time only: save 20% off on orders.",
    type: "PERCENTAGE",
    value: 0.2,
    expirationDate: "2025-06-15T13:00:00.000Z",
    usageLimit: 250,
    createdAt: "2025-05-03T13:00:00.000Z",
    updatedAt: "2025-05-03T13:00:00.000Z",
  },
  {
    id: "Qf69q7gjthG",
    code: "CHAMPIONSCUP",
    description:
      "Save 20% off your order for the Champions Cup by Elite Tournaments.",
    type: "PERCENTAGE",
    value: 0.2,
    expirationDate: "2025-06-13T13:00:00.000Z",
    usageLimit: 100,
    eventId: "cdqnJ9kc9Ww",
    createdAt: "2025-06-02T20:21:45.000Z",
    updatedAt: "2025-06-02T20:21:45.000Z",
  },
  {
    id: "zHmkFPMTCLw",
    code: "CAPITALCUP",
    description:
      "Save 20% off your order for the Capital Cup by Elite Tournaments.",
    type: "PERCENTAGE",
    value: 0.2,
    expirationDate: "2025-06-30T13:00:00.000Z",
    usageLimit: 100,
    eventId: "nmKdDGmMWqg",
    createdAt: "2025-06-02T20:21:45.000Z",
    updatedAt: "2025-06-02T20:21:45.000Z",
  },
  {
    id: "Q9JkqkgntGt",
    code: "NAPTOWN",
    description:
      "Save 20% off your order for the Naptown Challenge by HoganLax.",
    type: "PERCENTAGE",
    value: 0.2,
    expirationDate: "2025-06-23T13:00:00.000Z",
    usageLimit: 100,
    eventId: "BtQ9z9z6mcG",
    createdAt: "2025-07-02T20:21:45.000Z",
    updatedAt: "2025-07-02T20:21:45.000Z",
  },
  {
    id: "R7DjbFrH6cd",
    code: "SUMMEREXPOSURE",
    description: "Save 20% off bookings for Summer Exposure.",
    type: "PERCENTAGE",
    value: 0.2,
    expirationDate: "2025-06-10T13:00:00.000Z",
    usageLimit: 100,
    eventId: "fBTB9qcKkjR",
    createdAt: "2025-06-06T20:21:45.000Z",
    updatedAt: "2025-06-06T20:21:45.000Z",
  },
  {
    id: "qMmLCb6bzFW",
    code: "HOGANHERSHEY",
    description: "Save 20% off your order for Hogan Hershey!",
    type: "PERCENTAGE",
    value: 0.2,
    expirationDate: "2025-06-30T13:00:00.000Z",
    usageLimit: 100,
    eventId: "hWPwcDhbcnJ",
    createdAt: "2025-06-06T20:21:45.000Z",
    updatedAt: "2025-06-06T20:21:45.000Z",
  },
  {
    id: "d7rNTjnc9PL",
    code: "TENTTASTIC",
    description: "20% off your order.",
    type: "PERCENTAGE",
    value: 0.2,
    isShowable: false,
    createdAt: "2025-06-26T20:21:45.000Z",
    updatedAt: "2025-06-26T20:21:45.000Z",
  },
  {
    id: "KLGhfq9dFCm",
    code: "BESTINTENTS",
    description: "30% off your order.",
    type: "PERCENTAGE",
    value: 0.3,
    isShowable: false,
    createdAt: "2025-06-26T20:21:45.000Z",
    updatedAt: "2025-06-26T20:21:45.000Z",
  },
];

export {
  dbAddOns,
  dbPackages,
  dbTournaments,
  dbEventProductAvailability,
  dbDiscounts,
};
